// import React, { useState } from 'react';
// import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';



// const Header = () => {
//   const [isNavOpen, setIsNavOpen] = useState(false);
//   const [isSearchOpen] = useState(false);


//   const toggleNav = () => {
//     setIsNavOpen(!isNavOpen);
//   };


//   return (
//     <header className>
//       {/* Header Top */}
//       <div className="header-top bgg-darkk pt-md-2">
//         <div className="container">
//           <div className="row justify-content-center justify-content-xl-between align-items-center">
//             <div className="col-auto">
//               <div className="header-top-contact">
//                 <ul className='anchor d-md-flex'>
//                   <li className='px-md-5 fw-bold'>
//                     <a className='text-white' href="tel:+919011955415">
//                       <i className="fas fa-phone-volume text-white"></i> +91 9011955415
//                     </a>
//                   </li>
                   
//                   <li>
//                     <a className='text-white' href="mailto:  booking@srscabservice.com">
//                       <i className="far fa-envelope text-white"></i>
//                       <span className='text-white fw-bold'>   booking@srscabservice.com</span>
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>

//       {/* Main Navigation */}
//       <div className="main-navigation">
//         <Navbar expand="lg">
//           <Container>
//             <img src="/images/logo.jpg" className='logoo' alt="logo" />
//             <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
//               <i className="fas fa-bars darkcolorr"></i> 
//             </Navbar.Toggle>

//             <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
//               <Nav className="mx-auto">
//                 <Nav.Link href="/" className='fw-bold nav-item'>Home</Nav.Link>
//                 <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>
//                   <NavDropdown.Item href="/about-us" className='fw-bold nav-item'>About Us</NavDropdown.Item>
//                   <NavDropdown.Item href="/term-condition" className='fw-bold nav-item'>Term & Condition</NavDropdown.Item>
//                   <NavDropdown.Item href="/privacy-policy" className='fw-bold '>Privacy Policy</NavDropdown.Item>
                 
//                 </NavDropdown>
//                 <Nav.Link href="/services" className='fw-bold nav-item'>Services</Nav.Link>
//                 <Nav.Link href="/our-fleet" className='fw-bold nav-item'>Our Fleet</Nav.Link>
//                 <Nav.Link href="/packages" className='fw-bold nav-item'>Packages</Nav.Link>
//                 <Nav.Link href="/booking" className='fw-bold nav-item'>Online Booking</Nav.Link>
//                 <Nav.Link href="/gallery" className='fw-bold nav-item'>Gallery</Nav.Link>
//                 <NavDropdown title="Contact Us" id="contact-dropdown" className='fw-bold'>
//                   <NavDropdown.Item href="/contact-us" className='fw-bold nav-item'>Contact Us</NavDropdown.Item>
//                   <NavDropdown.Item href="/enquiry" className='fw-bold'>Enquiry</NavDropdown.Item>
//                 </NavDropdown>
//               </Nav>
           
//             </Navbar.Collapse>
            
//           </Container>
         
//         </Navbar>
//       </div>

//       {/* Search Area */}
//       {isSearchOpen && (
//         <div className="search-area">
//           <form action="#">
//             <div className="form-group">
//               <input type="text" className="form-control" placeholder="Type Keyword..." />
//               <button type="submit" className="search-icon-btn">
//                 <i className="far fa-search"></i>
//               </button>
//             </div>
//           </form>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Header;



import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSearchOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const handleNavItemClick = () => {
    setIsNavOpen(false);
  };

  return (
    <header>
      {/* Header Top */}
      <div className="header-top bgg-darkk pt-md-2">
  <div className="container">
    <div className="row justify-content-center justify-content-xl-between align-items-center">

      {/* Left: Contact Info */}
      <div className="col-auto">
        <div className="header-top-contact">
          <ul className="anchor d-md-flex mb-0">
            <li className="px-md-5 fw-bold">
              <a className="text-white" href="tel:+919011955415">
                <i className="fas fa-phone-volume text-white"></i> +91 9011955415
              </a>
            </li>
            <li>
              <a className="text-white" href="mailto:booking@srscabservice.com">
                <i className="far fa-envelope text-white"></i>
                <span className="text-white fw-bold"> booking@srscabservice.com</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Right: Social Media */}
      <div className="col-auto">
        <div className="header-social">
          <ul className="d-flex mb-0">
            <li className="mx-2">
              <a href="https://www.facebook.com/profile.php?id=61572096068790" className="text-white">
                <i className="fab fa-facebook-f"></i>
              </a>
            </li>
            <li className="mx-2">
              <a href="https://www.instagram.com/srscabservice/" className="text-white">
                <i className="fab fa-instagram"></i>
              </a>
            </li>
            <li className="mx-2">
              <a href="https://x.com/SSuryvansh25388" className="text-white">
                <i className="fab fa-twitter"></i>
              </a>
            </li>
            <li className="mx-2">
              <a href="https://www.pinterest.com/srstourstravals/" className="text-white">
          <i className="fab fa-pinterest-p"></i>
        </a>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</div>

      {/* Main Navigation */}
      <div className="main-navigation">
        <Navbar expand="lg">
          <Container>
            <img src="/images/6.jpg" className="logoo" alt="logo" />
            <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
              <i className="fas fa-bars darkcolorr"></i>
            </Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
              <Nav className="mx-auto">
                <li className="nav-item">
                  <Link className="nav-link active fw-bold" to="/" onClick={handleNavItemClick}>Home</Link>
                </li>
                <NavDropdown title="About Us" id="about-us-dropdown" className="fw-bold">
                  <li className="nav-item">
                    <Link className="dropdown-item fw-bold" to="/about-us" onClick={handleNavItemClick}>About Us</Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link className="dropdown-item fw-bold" to="/Faqs" onClick={handleNavItemClick}>Faqs </Link>
                  </li> */}
                  <li className="nav-item">
                    <Link className="dropdown-item fw-bold" to="/term-condition" onClick={handleNavItemClick}>Term & Condition</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="dropdown-item fw-bold" to="/privacy-policy" onClick={handleNavItemClick}>Privacy Policy</Link>
                  </li>
                </NavDropdown>
                <li className="nav-item">
                  <Link className="nav-link active fw-bold" to="/services" onClick={handleNavItemClick}>Services</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link active fw-bold" to="/our-fleet" onClick={handleNavItemClick}>Our Fleet</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link active fw-bold" to="/packages" onClick={handleNavItemClick}>Packages</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link active fw-bold" to="/booking" onClick={handleNavItemClick}>Online Booking</Link>
                </li>
                

<NavDropdown title="Outstation Cabs" id="contact-dropdown" className="fw-bold">
                  <li className="nav-item">
                    <Link className="dropdown-item fw-bold" to="/Pune-Outstation-Cabs" onClick={handleNavItemClick}>Outstation Cabs</Link>
                  </li>
<li className="nav-item">
                    <Link className="dropdown-item fw-bold" to="/Corporate-Cab-Service-in-Pune" onClick={handleNavItemClick}> Corporate Cab Service </Link>
                  </li>

                 
                </NavDropdown>

                 <li className="nav-item">
                  <Link className="nav-link active fw-bold" to="/gallery" onClick={handleNavItemClick}>Gallery</Link>
                </li>
                <NavDropdown title="Contact Us" id="contact-dropdown" className="fw-bold">
                  <li className="nav-item">
                    <Link className="dropdown-item fw-bold" to="/contact-us" onClick={handleNavItemClick}>Contact Us</Link>
                  </li>
<li className="nav-item">
                    <Link className="dropdown-item fw-bold" to="/Faqs" onClick={handleNavItemClick}>Faqs</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="dropdown-item fw-bold" to="/enquiry" onClick={handleNavItemClick}>Enquiry</Link>
                  </li>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

      {/* Search Area */}
      {isSearchOpen && (
        <div className="search-area">
          <form action="#">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Type Keyword..." />
              <button type="submit" className="search-icon-btn">
                <i className="far fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header;